import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const NotificationPanel = ({
  title,
  actions,
  selected,
  credit,
  selectionKey,
  message,
  state,
}) => {
  const getActionMessage = () =>
    selected > 0 ? (
      <span>
        Click on <strong> Share </strong> to send a message to the selected
        contacts
      </span>
    ) : (
      <span>
        You must select at least one contact to be able to share with them
      </span>
    );
  return (
    <div className={`notification-panel-wrapper ${state}`}>
      <div className="inner-container">
        <div className="selection-counter">
          {selected !== null && (
            <ul>
              <li>{title}</li>
              <li className="total-selection">{selected}</li>
              {selectionKey && (
                <li className="credit-section">
                  /<strong>{credit}</strong>
                  <span className="total-selection-key">{selectionKey}</span>
                </li>
              )}
            </ul>
          )}
        </div>
        <div className="notification-message">
          <h3> {message || getActionMessage()} </h3>
        </div>
        <div className="notification-actions">
          {credit > 0 || !actions.secondary ? actions.primary : actions[state]}
        </div>
      </div>
    </div>
  );
};

NotificationPanel.propTypes = {
  title: PropTypes.string.isRequired,
  selectionKey: PropTypes.string,
  selected: PropTypes.number,
  credit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actions: PropTypes.shape({
    primary: PropTypes.node,
    secondary: PropTypes.node,
  }),
  state: PropTypes.oneOf(['primary', 'secondary']),
  message: PropTypes.object.isRequired,
};

NotificationPanel.defaultProps = {
  actions: null,
  selectionKey: null,
  selected: null,
  credit: null,
  message: null,
  state: 'primary',
};

export default NotificationPanel;
